<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editIssueCategory') }}</h1>
      <div class="form-container">
        <IssueCategoryForm :data="relations.instance" @save="save"></IssueCategoryForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import IssueCategoryForm from "@/components/IssueCategoryForm"

  export default {
    components: {
      IssueCategoryForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'issue_categories', payload}).then(() =>
          this.$router.push({ name: 'issueCategories'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'issue_categories', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'issueCategories', path: 'issueCategories'},
          {name: 'editIssueCategory'}
        ]
      }
    }
  }
</script>